import i from "../string/truncate.mjs";
function s(n, t) {
  return t ? `${t}.${n}` : n;
}
function o(n, t, u) {
  return Object.entries(n).reduce(
    (f, [m, r]) => {
      const e = s(m, u);
      return t[e] !== void 0 ? f : typeof r == "string" ? (t[e] = i(r, 100), f) : typeof r == "number" ? (t[e] = i(r.toString(), 100), f) : typeof r == "object" && r ? o(r, f, e) : (t[e] = i(String(r), 100), t);
    },
    t
  );
}
function g(n) {
  if (n)
    return o(n, {});
}
export {
  g as default
};
